import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import Utility from "../../../../utility/utility";
import RoadMapInfoView from "./roadmapinfo_view";
import EventManager from "../../../../manager/event_manager";

const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("RoadMapInfo", true)
export default class RoadMapInfo extends ModuleBase<RoadMapInfoView, null> {

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/longhudou/roadmapinfo";
        this.viewType = RoadMapInfoView;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            default:
                break;
        }
    }

    onInit() {
        
    }

    onShow(intentData) {
        this.bindEvent()
        this.updateShow(intentData)
    }

    updateShow(intentData:any){
        
        this.view.myRoadmap.onRefreshDisplay(intentData,null)
        this.view.initShow(intentData)
    }

    private bindEvent() {
        this.eventBind("event_update_betresulthistory", this.updateShow);
    }

    onDestroy(){
        this.eventUnBind("event_update_betresulthistory", this.updateShow);
    }


}
